<template>
  <v-container class="d-flex fill-height align-center justify-center">
    <v-row v-if="$route.query.type && $route.query.type === 'financial'">
      <v-col lg="7" sm="9" class="mx-auto d-flex justify-center align-center flex-column">
        <v-progress-circular
        color="error"
        :value="100"
        :size="147"
        :width="10"
        >        
          <v-icon color="error" size="90px">mdi-alert</v-icon>
        </v-progress-circular>
        <h6 class="display-1 font-wight-bold text-center mt-4 mb-1"> {{ $t('components.accessBlocked.financial.title') }} </h6>
        <p class="text-justify mb-10">
          {{ $t('components.accessBlocked.financial.description') }}
          <span class="primary--text font-weight-medium">paula.garcia@sociallearning.io</span>.
        </p>
        <div class="d-flex justify-center">
          <Button
            color="primary"
            :text="$t('components.accessBlocked.financial.actions.primary.label')"
            @clicked="toPayment"
          />
        </div>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col sm="6" class="mx-auto d-flex justify-center flex-column">
        <v-icon color="warning" size="154px">mdi-shield-alert</v-icon>
        <h6 class="display-1 font-wight-bold text-center mt-4 mb-1">{{$t('components.accessBlocked.default.title')}}</h6>
        <h6 class="headline text-center mt-4 mb-8">{{$t('components.accessBlocked.default.subtitle')}}</h6>
        <p class="text-center mb-10" v-html="$t('components.accessBlocked.default.description', { theme: $theme })"></p>
        <div class="d-flex justify-center">
          <v-btn
            large
            rounded
            text
            color="primary"
            class="my-2 px-8 text-uppercase"
            @click="toHome"
          >{{$t('actions.goToHome')}}</v-btn>
          <v-btn
            large
            rounded
            color="primary"
            class="my-2 px-8 text-uppercase"
            @click="logout"
          >{{$t('actions.logout')}}</v-btn>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Button from '@/components/Button/Button'
export default {
    name: 'AccessBlocked',
    components:{
      Button
    },
    methods: {
      logout () {
        this.$auth.logout();
      },
      toHome () {
        this.$trackEvent('Bloqueo por sancion', 'Clk_BtnIrInicio_Inicio', 'Regularizacion de pago')
        this.$router.replace('/')
      },
      toPayment () {
        this.$trackEvent('Bloqueo por sancion', 'Clk_BtnIrPagos_Pagos', 'Regularizacion de pago')
        this.$router.replace('/payments')
      }
    }
};
</script>
